import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";

import { UitkPrimaryButton } from "uitk-react-button";

import { PackageCard } from "./PackageCard";
import { PackageCardImageLeftMobile } from "./PackageCardImageLeftMobile";
import { PackageCardImageLeft } from "./PackageCardImageLeft";
import { PackageCardMobile } from "./PackageCardMobile";

import { FlexClickTracker } from "components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";

import { PackageCardsProps } from "components/flexComponents/Packages/typings";

const ButtonTracked = FlexClickTracker(UitkPrimaryButton);
const keyHelper = new ItemKeyHelper("PackageCards");

const scrollToWizardAndFocusOnDate = (): void => {
  const bundledPackageSelector = "#wizard-package-pwa-1";
  const allInclusiveSelector = "#All-inclusive-vacations";
  const allInclusiveWizard = document.querySelector(allInclusiveSelector);
  const activeWizardSelector = allInclusiveWizard?.classList?.contains("active")
    ? allInclusiveSelector
    : bundledPackageSelector;
  const activeWizard = document.querySelector(activeWizardSelector);
  activeWizard?.scrollIntoView({ block: "start", behavior: "smooth" });
  //Focus on the departure date field
  const activeStartDateInput = document.querySelector(`${activeWizardSelector} #d1-btn`) as HTMLElement;
  activeStartDateInput.focus({ preventScroll: true });
};

export const PackageCards = ({
  context,
  packages,
  isMobile,
  isFullWidth,
  viewType,
  showChooseYourDates,
}: PackageCardsProps) => {
  const { formatText } = useLocalization();
  const languageAndCountryCodeArray = splitLocaleIntoLanguageAndCountryCode(context.locale);
  viewType = viewType ? viewType : "default";
  const componentMap = {
    "image-left-expando-mobile": PackageCardImageLeftMobile,
    "image-left-expando": PackageCardImageLeft,
    default: PackageCard,
    "default-mobile": PackageCardMobile,
  };

  const PackageCardComponent = componentMap[`${viewType}${isMobile ? "-mobile" : ""}`] ?? PackageCardMobile;

  return (
    <>
      {packages?.map((packageItem, index: number) => (
        <PackageCardComponent
          packageItem={packageItem}
          key={keyHelper.next()}
          index={index}
          language={languageAndCountryCodeArray}
        />
      ))}

      {showChooseYourDates && (
        <div className="uitk-type-center">
          <ButtonTracked
            text={formatText("wizard.sticky.cta.label")}
            onClick={scrollToWizardAndFocusOnDate}
            className="all-t-margin-three all-b-margin-two"
            moduleName="packages"
            rfrr="ChooseYourDatesCTA"
            isFullWidth={isFullWidth}
            data-testid="choose-your-dates"
          />
        </div>
      )}
    </>
  );
};

export const splitLocaleIntoLanguageAndCountryCode = (locale?: string): string[] | undefined => locale?.split(/[_-]/);
